<template>
    <div>
      <b-container class="mt-5 mb-5">
        <h1 class="fs-4 font-weight-bold mb-4">Uitnodigingen</h1>
        
        <template v-if="!invites.length">
            <b-card no-body>
            <b-card-body>
                <div class="text-center text-muted mt-4 mb-4">
                    <font-awesome-icon icon="envelope" class="mb-2" size="2x" />
                    <div class="text-dark fs-5">Geen uitnodigingen gevonden.</div>
                    <p>Je kunt uitnodigingen aanmaken nadat je het evenement hebt gepubliceerd.</p>
                </div>
            </b-card-body>
            </b-card>
        </template>

        <template v-else>
            <b-card class="mb-3">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>Gebruiker</th>
                            <th>Actie</th>
                            <th class="text-right">Datum</th>
                        </tr>
                    </thead>
                    <tbody>

                    </tbody>
                </table>
            </b-card>
        </template>
      </b-container>
    </div>
</template>
  
<script>
    export default {
        metaInfo: {
            title: 'Uitnodigingen',
        },
        components: {},
        data() {
            return {
                invites: []
            }
        },
        computed: {},
        methods: {},
        created() {},
    }
</script>